import { Link } from 'react-router-dom';
import { Button } from 'primereact/button';
import Footer from "../../components/footer";
import Header from "../../components/header";
import Colors from "../../utils/colors";





function ProductAccounts(){
return(
<>
    <Header />
    <div className="products-header-bg">
        <div className="flex-center" style={{padding:"3rem 2rem"}}>
            <div className="col-lg-10">
                <div className="row no-margin no-padding-on-mobile" style={{paddingTop:"2rem"}}>
                    <div className="col-md-7 no-padding" style={{marginBottom:"1px"}}>
                        <div className="product-label">Products</div>
                        <br/>
                        <div className="section-title" style={{textAlign:"left",}}>Accounts</div>
                        <div style={{margin:"5px", fontSize:"1rem"}}>Product intro</div>
                        <div className="flex-row" style={{margin:"15px 0px"}} >
                            <div style={{margin:"5px 8px 5px 0px", }}>
                                <Link to="mailto:sales@monytrack.com?subject=Schedule a demo for MonyTrack Business&body=Hello MonyTrack Team,%0D%0A %0D%0A..." >
                                    <Button
                                    style={{background:"linear-gradient(to right, #F5FBFE,  #F5FBFE, #f6f7f8)", color:Colors.black, fontSize:"1.1rem", borderRadius:"5px", borderColor:Colors.gray2, padding:".5rem 1.2rem", }} >Book a free demo</Button>
                                </Link>
                            </div>
                            <div style={{margin:"5px 0px 5px 8px"}}>
                                <a target="_blank" href="https://business.monytrack.com/auth/register" style={{position:'relative', zIndex:0}}>
                                    <Button autoFocus
                                        style={{ backgroundColor:Colors.primary, color:Colors.light, fontWeight:'normal',  fontSize:"1.1rem", borderRadius:"5px", borderColor:Colors.primary, padding:".5rem 1.2rem"}} >Start Now</Button>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-5 no-padding">
                        <div className="flex-center" style={{width:"100%", height:"100%", marginTop:'10px'}}>
                            <div className="col-md-10 h-img-box" >
                                <div style={{background:"linear-gradient( to bottom left, #e931db, #0fbae3)", borderRadius:"20px"}}>
                                    <img src="/img/img/card-p.jpg" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <Footer/>
</>
)
}
export default ProductAccounts;